/**
 * ModuleGuard — Faz 50
 *
 * Route-level guard. Non-admin kullanıcılar yetkisi olmayan bir modülün
 * sub-route'una girmeye çalışırsa `/erisim-yok` sayfasına yönlendirilir.
 * Admin (role === "yonetici") her modüle otomatik erişir.
 *
 * Finansal Kontrol & Gayri Resmi Kasa gibi hard-coded whitelist'li modüller
 * MODULE_ACCESS_EXEMPT_PREFIXES içinde listelenir — kendi guard'ları vardır.
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  getSlugForPath,
  isPathExemptFromModuleAccess,
} from "@/lib/moduleMenus";
import SiteAccessGuard from "@/components/SiteAccessGuard";

export default function ModuleGuard({ children }) {
  const { user } = useAuth();
  const loc = useLocation();

  if (!user) return children; // auth guard başka yerde

  // Admin → bypass
  if ((user.role || "").toLowerCase() === "yonetici") return children;

  // Exempt path'ler → bypass
  if (isPathExemptFromModuleAccess(loc.pathname)) return children;

  const slug = getSlugForPath(loc.pathname);
  if (!slug) return children; // bilinmeyen path, guard etkisiz

  const access = Array.isArray(user.effective_module_access)
    ? user.effective_module_access
    : (Array.isArray(user.module_access) ? user.module_access : []);
  if (!access.includes(slug)) {
    // Modül düzeyinde yetki yok → genel erişim yok sayfası
    return (
      <Navigate
        to="/erisim-yok"
        replace
        state={{ from: loc.pathname, slug }}
      />
    );
  }
  // Modül yetkisi var — şantiye-bazlı yetki kontrolünü SiteAccessGuard yapar
  return <SiteAccessGuard>{children}</SiteAccessGuard>;
}
